import { Call } from "@helpers/fetch";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    students: null,
    status: null,
    scholarships: null,
    teachers: null,
    humanResources: null,
    incidents: null,
};

export const Dashboard = createSlice({
    name: "dashboard",
    initialState,
    reducers: {
        setStudents: (state, action) => {
            state.students = action.payload;
        },
        setStatus: (state, action) => {
            state.status = action.payload;
        },
        setScholarships: (state, action) => {
            state.scholarships = action.payload;
        },
        setTeachers: (state, action) => {
            state.teachers = action.payload;
        },
        setHumanResources: (state, action) => {
            state.humanResources = action.payload;
        },
        setIncidents: (state, action) => {
            state.incidents = action.payload;
        },
    },
});

export const {
    setStudents,
    setStatus,
    setScholarships,
    setTeachers,
    setHumanResources,
    setIncidents,
} = Dashboard.actions;

export default Dashboard.reducer;

export const startGetStudentsDashboard = ({ cycle }) => {
    return async (dispatch) => {
        dispatch(setStudents(null));

        const params = new URLSearchParams();
        params.set("cycle", cycle.name);

        const resp = await Call(
            "students/dashboard",
            "GET",
            params.toString()
        );

        if (resp.success) {
            dispatch(setStudents(resp.success));
        } else {
            dispatch(setStudents(null));
        }
    };
};

export const startGetScholarshipsDashboard = ({ cycle }) => {
    return async (dispatch) => {
        dispatch(setScholarships(null));

        const params = new URLSearchParams();
        params.set("cycle", cycle.name);

        const resp = await Call(
            "operators/scholarship/dashboard",
            "GET",
            params.toString()
        );

        if (resp.success) {
            dispatch(setScholarships(resp.success));
        } else {
            dispatch(setScholarships(null));
        }
    };
};

export const startGetTeachersDashboard = ({ cycle }) => {
    return async (dispatch) => {
        dispatch(setTeachers(null));

        const params = new URLSearchParams();
        params.set("cycle", cycle.name);

        const resp = await Call("teachers/dashboard", "GET", params.toString());

        if (resp.success) {
            dispatch(setTeachers(resp.success));
        } else {
            dispatch(setTeachers(null));
        }
    };
};

export const startGetHumanResourcesDashboard = () => {
    return async (dispatch) => {
        dispatch(setHumanResources(null));
        dispatch(setIncidents(null));

        const resp = await Call("users/employee/dashboard", "GET");

        if (resp.success) {
            dispatch(setIncidents(resp.success.incidents));
            delete resp.success.incidents;
            dispatch(setHumanResources(resp.success));
        } else {
            dispatch(setHumanResources(null));
            dispatch(setIncidents(null));
        }
    };
};
